import Vue from 'vue'

import BKButton from '@/components/AppShared/BKButton.vue'
import BKLoader from '@/components/BKLoader.vue'
import BKSort from '@/components/BKSort.vue'

Vue.component('BKButton', BKButton)
Vue.component('BKLoader', BKLoader)
Vue.component('BKSort', BKSort)
